export default "__VITE_ASSET__D_ixg8Os__";